import { render, staticRenderFns } from "./longyuan.vue?vue&type=template&id=ae8796e4&"
import script from "./longyuan.vue?vue&type=script&lang=js&"
export * from "./longyuan.vue?vue&type=script&lang=js&"
import style0 from "./longyuan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports